import React from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';
import { cn } from '../../../utils/cn';

const GeneratePdfConfirmDialog = ({ open, documentTitle, onCancel, onConfirm }) => {
  if (!open) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h3 className="text-lg font-semibold">
        Atenção antes de gerar o documento
      </h3>

      {documentTitle ? (
        <p className="text-sm font-medium text-foreground mt-3 truncate">
          {documentTitle}
        </p>
      ) : null}

      <p className="text-sm text-muted-foreground mt-2">
        Este modelo de documento é uma sugestão automatizada e{' '}
        <strong>não substitui assessoria jurídica.</strong>
      </p>

      <div className={cn(MODAL_DIALOG_ACTIONS_END, 'mt-6')}>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>

        <Button variant="default" onClick={onConfirm}>
          Confirmar e Gerar
        </Button>
      </div>
    </ModalShell>
  );
};

export default GeneratePdfConfirmDialog;
